if (location.href.indexOf('/reportdid/get-report') >= 0) {
    document.addEventListener('DOMContentLoaded', async () => {
        try {
            const response = await fetch('/reportdid/check-report');

            if (!response.ok) {
                location.href = '/reportdid/error-did';
                return;
            }

            const status = await response.text();

            if (status == '1') {
                location.href = `/reportdid/report-done?v=${Date.now()}`;
                return;
            }

            location.href = '/reportdid/error-did';
        } catch (error) {
            location.href = '/reportdid/error-did';
        }
    });
}
